import { NavDropdown } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useTranslation } from 'react-i18next';
import { Outlet } from "react-router-dom";
import { getUserInfo, isLoggedIn, redirectToLoginUri } from '../functions/authentication';
import { setLanguage } from '../functions/language';
import { ROUTE_ABOUT, ROUTE_FRIENDS, ROUTE_GAMES_LIBRARY, ROUTE_GAME_EXTRACTIONS, ROUTE_GAME_SEARCH, ROUTE_GAME_SESSIONS, ROUTE_GAME_STATS, ROUTE_PRODUCT_SEARCH, ROUTE_PROFILE, ROUTE_PUBLIC_LINK, ROUTE_RANDOM_GAME } from '../functions/route';
import { authEndpoint } from '../functions/endpoint';
import './Navigation.css';

function Navigation() {
    const { t, i18n } = useTranslation('messages');

    const languageDropdown = (
        <NavDropdown title={t('main.navbar.language')} id="nav-lang-dropdown">
            <NavDropdown.Item onClick={() => changeLanguage(i18n, 'en', setLanguage)}>
                {t('main.navbar.language_en')}
            </NavDropdown.Item>
            <NavDropdown.Item onClick={() => changeLanguage(i18n, 'it', setLanguage)}>
                {t('main.navbar.language_it')}
            </NavDropdown.Item>
        </NavDropdown>
    );

    if (isLoggedIn()) {
        const username = JSON.parse(getUserInfo()).firstname;
        return (
            <div>
                <Navbar className="nav-main" variant="dark" expand="lg" sticky="top">
                    <Container>
                        <Navbar.Brand href="/" className="nav-brand-text">{t('main.navbar.brand')}</Navbar.Brand>
                        <Navbar.Toggle aria-controls="main-navbar" />
                        <Navbar.Collapse id="main-navbar">
                            <Nav className="me-auto">
                                <Nav.Link href="/">{t('main.navbar.home')}</Nav.Link>

                                <NavDropdown title={t('main.navbar.nav_search')} id="nav-search-dropdown">
                                    <NavDropdown.Item href={"/" + ROUTE_GAME_SEARCH}>
                                        {t('main.navbar.game_search')}
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href={"/" + ROUTE_PRODUCT_SEARCH}>
                                        {t('main.navbar.store_search')}
                                    </NavDropdown.Item>
                                </NavDropdown>

                                <NavDropdown title={t('main.navbar.nav_library')} id="nav-library-dropdown">
                                    <NavDropdown.Item href={"/" + ROUTE_GAMES_LIBRARY}>
                                        {t('main.navbar.games_library')}
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href={"/" + ROUTE_RANDOM_GAME}>
                                        {t('main.navbar.random_games')}
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href={"/" + ROUTE_GAME_EXTRACTIONS}>
                                        {t('main.navbar.game_extractions')}
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item href={"/" + ROUTE_PUBLIC_LINK}>
                                        {t('main.navbar.public_link')}
                                    </NavDropdown.Item>
                                </NavDropdown>

                                <NavDropdown title={t('main.navbar.nav_sessions')} id="nav-sessions-dropdown">
                                    <NavDropdown.Item href={"/" + ROUTE_GAME_SESSIONS}>
                                        {t('main.navbar.game_sessions')}
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href={"/" + ROUTE_GAME_STATS}>
                                        {t('main.navbar.game_stats')}
                                    </NavDropdown.Item>
                                </NavDropdown>

                                <Nav.Link href={"/" + ROUTE_FRIENDS}>{t('main.navbar.friends')}</Nav.Link>
                                <Nav.Link href={"/" + ROUTE_ABOUT}>{t('main.navbar.about')}</Nav.Link>
                            </Nav>
                            <Nav>
                                {languageDropdown}
                                <NavDropdown
                                    title={t('main.navbar.greeting', { name: username })}
                                    id="nav-user-dropdown"
                                    align="end"
                                >
                                    <NavDropdown.Item href={"/" + ROUTE_PROFILE}>
                                        {t('main.navbar.profile')}
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item href="/logout">
                                        {t('main.navbar.logout')}
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                <Outlet />
            </div>
        );
    }

    return (
        <div>
            <Navbar className="nav-main" variant="dark" expand="lg" sticky="top">
                <Container>
                    <Navbar.Brand href="/" className="nav-brand-text">{t('main.navbar.brand')}</Navbar.Brand>
                    <Navbar.Toggle aria-controls="main-navbar" />
                    <Navbar.Collapse id="main-navbar">
                        <Nav className="me-auto">
                            <Nav.Link href="/">{t('main.navbar.home')}</Nav.Link>
                            <Nav.Link href={"/" + ROUTE_ABOUT}>{t('main.navbar.about')}</Nav.Link>
                        </Nav>
                        <Nav>
                            {languageDropdown}
                            <Nav.Link onClick={() => redirectToLoginUri(authEndpoint)}>{t('main.navbar.login')}</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Outlet />
        </div>
    );
}

function changeLanguage(i18n, lang, setLanguage) {
    i18n.changeLanguage(lang);
    setLanguage(lang);
}

export default Navigation;
